import draggable from "vuedraggable";
import GeneralMixin from './GeneralMixin';
import ResourcesMixin from '@/app/shared/mixins/BaseResourcesGestaoMixin';

const defaultFeatureInfo = {
                        queryable: false,
                        format: null,
                    };

export default {
    mixins: [
        GeneralMixin,
        ResourcesMixin,
    ],
    components: {
        draggable,
        MaterialColorPicker: () => import(/* webpackChunkName: "color-picker" */ '@/components/form/MaterialColorPicker.vue'),
        UploadMultipleImage: () => import(/* webpackChunkName: "upload-multiple-image" */ '@/components/form/UploadMultipleImage.vue'),
        HelpSpan: () => import(/* webpackChunkName: "help-span" */ '@/components/form/HelpSpan.vue'),
    },
    props: {
        groupTitle: {
            type: String,
            default: 'global.group',
        },
    },
    data() {
        return {
            loading: false,
            pivotResources: 'resourcelayer',
            lists: {
                loaded: false,
                onoff: [{'id': 1, 'name': 'Sim', 'code': true}, {'id': 2, 'name': 'Não', 'code': false}],
                groups: [],
                featureinfoformats: [],
            },
            form: {
                id: null,
                behavior: null,
            },
            table: {
                addParamsToUrl: true,
                loadingMsg: 'Loading...',
                notFoundMsg: 'Sem resultados',
                orderByTemplate: 'Ordenar por {field}',
                autoUpdateFilter: true,
                autoUpdateExternalFilter: false,
                settings: {},
                filters: {
                    q: '',
                },
                columns: [
                    {
                        label: 'Nome',
                        field:  'name',
                        class: '',
                        sortable: true,
                    },
                ],
            },
            query: '',
            queryParams: {
                filters: 'filter',
            },
        }
    },
    mounted() {
        if(this.$route.params.type){
            this.form.behavior = this.$route.params.type;
        }

        this.loadLists();
        if(!this.form.id){
            this.startLoadResources=true;
        }
    },
    computed: {
        isLayer() {
            return this.form.behavior == 'resource';
        },
        detailTitle() {
            return this.isLayer ? this.pageTitle : this.$t(this.groupTitle);
        },
        titleItem() {
            return (this.form.id ? this.updateTitle : this.addTitle) + ' - ' + this.detailTitle;
        },
        groups() {
            return this.lists.groups || [];
        }
    },
    methods: {
        callbackLoadItem: function() {
            this.startLoadResources=true;
            ['icon_layer', 'legend_layer'].forEach(k => {
                if(this.form[k]){
                    this.form[k].forEach( item => {
                        this[k].push(Object.assign(item, {'path': item.filename}));
                    })
                }
            });
            if(!this.form.feature_info){
                this.form.feature_info = Object.assign({}, defaultFeatureInfo);
            }
        },
    },
    watch: {

    },
};
